import InputField from '../../../../components/common/Form/InputField/InputField';
import TextArea from '../../../../components/common/Form/TextArea/TextArea';
import { AssessoriaAcompanyantEnum } from '../../../../types/assessories/assessoria_acompanyant.d';
import { AssessoriaMobilitat } from '../../../../types/assessories/assessoria_mobilitat.d';
import { AssessoriaMobilitatDerivacioEnum } from '../../../../types/assessories/assessoria_mobilitat_derivacio.d';
import { AssessoriaZonaGeograficaEnum } from '../../../../types/assessories/assessoria_zona_geografica.d';

interface SectionMobilitatInternacionalProps {
  realitzada: AssessoriaMobilitat;
}

const SectionMobilitatInternacional: React.FC<
  SectionMobilitatInternacionalProps
> = ({ realitzada }: SectionMobilitatInternacionalProps) => {
  return (
    <>
      <InputField
        label="Acompanyant"
        input={{
          type: 'text',
          defaultValue: realitzada.acompanyant
            ? AssessoriaAcompanyantEnum[realitzada.acompanyant]
            : '',
          readOnly: true,
        }}
      />
      <InputField
        label="Assistents"
        input={{
          type: 'text',
          defaultValue: realitzada?.assistents,
          readOnly: true,
        }}
      />
      <InputField
        label="Sector professional"
        input={{
          type: 'text',
          defaultValue: realitzada?.sector_professional?.name,
          readOnly: true,
        }}
      />
      <TextArea
        label="Temàtica"
        textarea={{
          defaultValue:
            realitzada?.tematiques?.map((el) => el.name).join(', ') || [],
          readOnly: true,
          name: 'tematica',
        }}
      />
      <TextArea
        label="Sub temàtica"
        textarea={{
          defaultValue:
            realitzada?.subtematiques?.map((el) => el.name).join(', ') || [],
          readOnly: true,
          name: 'subtematica',
        }}
      />
      <TextArea
        label="Derivacio"
        textarea={{
          defaultValue:
            realitzada?.derivacio
              ?.map((el) => AssessoriaMobilitatDerivacioEnum[el])
              .join(', ') || [],
          readOnly: true,
          name: 'derivacio',
        }}
      />
      <InputField
        label="Zona geografica"
        input={{
          type: 'text',
          defaultValue: realitzada.zona_geografica
            ? AssessoriaZonaGeograficaEnum[realitzada.zona_geografica]
            : '',
          readOnly: true,
        }}
      />
      <InputField
        label="Pais"
        input={{
          type: 'text',
          defaultValue: realitzada?.pais,
          readOnly: true,
        }}
      />
      <InputField
        label="Valoració assessor"
        input={{
          type: 'text',
          defaultValue: realitzada?.valoracio_assessor,
          readOnly: true,
        }}
      />
      <TextArea
        label="Comentaris"
        textarea={{
          defaultValue: realitzada?.comentaris,
          readOnly: true,
          name: 'comentaris',
        }}
      />
    </>
  );
};

export default SectionMobilitatInternacional;
